export class Manager {
  static fromJson(json: any): Manager {
    return new Manager(
      json.id,
      json.name,
      json.acronym,
      json.type,
      json.number,
      json.rate,
      json.active
    );
  }

  static fromJsonArray(array): Manager[] {
    return array.map(Manager.fromJson);
  }

  constructor(
    public id: string,
    public name: string,
    public acronym: string,
    public type: string,
    public number: number,
    public rate: number,
    public active: boolean
  ) {}
}

export class ManagerResponse {
  public managers: Manager[];
  public total: number;
}
